import { SearchResultsSkeletonComponent } from "./components/searchResults.skeleton";
import { Base } from "./skeleton.base";

export const Skeleton = Object.assign(Base, {
    SearchResults: SearchResultsSkeletonComponent
});
